import React from 'react'
import { useTranslation } from 'react-i18next'
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker'
import { IconButton, InputAdornment } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import dayjs from 'dayjs'
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField'
import CustomActionBar from './CustomActionBar'

const DateBetweenFilterElement = ({ label, operator, value, handleValueChange, setFocused }) => {
    const { t } = useTranslation()

    const isValueEmpty = value === '' || value === null || value === undefined || JSON.stringify(value) === JSON.stringify({ from: null, to: null });
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateRangePicker
                closeOnSelect={false}
                format="DD/MM/YYYY"
                label={label ? t(label) : t(operator)}
                onAccept={(range) => {
                    const from = range[0] ? range[0].format('YYYY-MM-DD') : null
                    const to = range[1] ? range[1].format('YYYY-MM-DD') : null
                    if (!from || !to) {
                        handleValueChange({ from: null, to: null })
                    } else {
                        handleValueChange({ from: from, to: to })
                    }
                }}
                slotProps={{
                    textField: {
                        placeholder: '',
                        variant: 'filled',
                        sx: {
                            width: 'inherit'
                        },
                    },
                    actionBar: {
                        className: 'mtska-date-range',
                        handleValueChange,
                        actions:['clear']
                    },
                    layout: {
                        className: 'mtska-date-picker-selector'
                    }
                }}
                slots={{
                    field: SingleInputDateRangeField,
                    actionBar: CustomActionBar,
                }}
                value={[value?.from ? dayjs(value.from) : null, value?.to ? dayjs(value.to) : null]}
                className="form-element filter-element form-element-date-picker"
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                InputProps={!isValueEmpty && {
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton
                                size="small"
                                sx={{ padding: '4px' }}
                                onClick={() => handleValueChange({ from: null, to: null })}
                            >
                                <ClearIcon fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ),
                }}
            />
        </LocalizationProvider>
    )
}

export default DateBetweenFilterElement;